<div class="ocean">
  <div class="wave"></div>
  <div class="wave"></div>
</div>
<div class="container-fluid">
  <div class="row all-div align-items-center">
    <div class="col-lg-4 order-lg-1 order-md-3 order-3 order-sm-3 left">
      <h3>NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS</h3>
      <div class="video_box">
        <video
          id="my-video"
          class="video-js video-size w-100 h-auto"
          controls
          preload="auto"
          poster="{{ myLinksS3URL }}images/Image0231.png"
          data-setup="{}"
          autoplay="true"
          muted
          width="100%"
        >
          <source
            src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video2.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
    <div class="col-lg-4 order-1 order-lg-2 order-md-1 order-sm-1">
      <div class="logo">
        <img src="{{ onPassiveBaseUrl }}onpassive(october7)/images/logo.png" 
        alt="logo"/>
      </div>
      <div class="face p-4">
        <img
          src="{{ onPassiveBaseUrl }}onpassive(october7)/images/face-ai.gif"
          width="100%"
          alt="face-ai"
        />
      </div>
      <div class="light">
        <img
          src="{{ onPassiveBaseUrl }}onpassive(october7)/images/light.png"
          width="100%"
          alt="light"
        />
      </div>
    </div>
    <div
      class="col-lg-4 launching-soon order-2 order-lg-3 order-md-2 order-sm-2"
    >
      <div class="center-outer">
        <div class="center-inner">
          <div class="bubbles">
            <h2 class="ml7">
              <span class="text-wrapper">
                <span class="letters">Launching Soon</span>
              </span>
            </h2>
          </div>
          <div class="contents">
            <p>
              Looking for a business opportunity that builds not only your
              wealth but also your personality? Is there even a business like
              that? Yes, ONPASSIVE is such a brilliant opportunity that paves a
              way for a successful life. A network marketing business with an
              automated system is all set to help you be a better version of
              yourself. Be it your wealth, health, dreams or anything, ONPASSIVE
              got it all covered for you. Grow with ONPASSIVE and you will grow
              towards prosperity.
            </p>
          </div>

          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            target="_blank"
            rel="noopener"
          >
            <button class="btn btn-founder">Become a founder now</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
